import { PaymentMethodEnum, ReceiptTypeEnum } from "@prostocheck/shared";

/** Keys in the `common` namespace of `@prostocheck/i18n`. */
export const RECEIPT_TYPE_TITLE_KEY: Record<ReceiptTypeEnum, string> = {
  [ReceiptTypeEnum.Sale]: "receiptTitle.sale",
  [ReceiptTypeEnum.Return]: "receiptTitle.return",
  [ReceiptTypeEnum.Service]: "receiptTitle.service",
};

export const PAYMENT_METHOD_LABEL_KEY: Record<PaymentMethodEnum, string> = {
  [PaymentMethodEnum.Cash]: "paymentMethod.cash",
  [PaymentMethodEnum.Card]: "paymentMethod.card",
};
